<div
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
  class="connect-bg connect-channel"
>
  <h2>Add WhatsApp</h2>
  <h3>Step 1. Create a WhatsApp Business Account and link a phone number</h3>
  <button
    mat-raised-button
    fxFlex="none"
    type="submit"
    (click)="launchWhatsAppSignup()"
  >
    Embedded Signup
  </button>
  @if (showCoexistenceButton()) {
    <button
      mat-raised-button
      fxFlex="none"
      type="submit"
      (click)="launchWhatsAppCoexistenceSignup()"
    >
      Embedded Signup with Coexistence
    </button>
  }

  <h3 [ngClass]=""> Step 2. Connect your Whatsapp number with Hubtype </h3>
  @if (feedback) {
    <p class="text-feedback"> There was a problem getting the phone number </p>
  }

  @if (noPhoneNumbersFeedback) {
    <p>
      You don't have any Phone Number registered. Please register one and
      <span class="refresh-fb-pages" (click)="launchWhatsAppSignup()"
        >refresh<mat-icon>refresh</mat-icon></span
      >
    </p>
  }
  @if (phoneNumbers && phoneNumbers?.length) {
    <p> The messages you get to this phone number will be sent to Hubtype: </p>
  }

  @if (loadingPhoneNumbers) {
    <div fxFlexAlign="center" @loadData>
      <mat-spinner [diameter]="32" [strokeWidth]="3.2"></mat-spinner>
    </div>
  }

  @if (phoneNumbers && !loadingPhoneNumbers) {
    <div
      fxFlex
      fxLayout="row"
      fxLayoutAlign="center center"
      class="phones-select"
    >
      <mat-select
        fxFlex="none"
        [(ngModel)]="selectedPhoneNumber"
        floatPlaceholder="never"
      >
        @for (phone of phoneNumbers; track phone) {
          <mat-option [value]="phone">
            <span
              >({{ phone.display_phone_name }}) {{ phone.display_phone_number }}
            </span>
          </mat-option>
        }
      </mat-select>
    </div>
  }
  <button
    mat-raised-button
    fxFlex="none"
    type="submit"
    [disabled]="!(phoneNumbers && selectedPhoneNumber)"
    (click)="addWhatsappCloud()"
  >
    Connect Phone Number
  </button>
</div>
